import { GENERATEUR_ISLANDS } from "./generateurRegistry";
import { mountIslands, whenIdle } from "./mount";

whenIdle(() => mountIslands(GENERATEUR_ISLANDS));
